// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('MixSection')
const satellites = [
  'mix-secondary',
  'mixed',
  'share',
  'mixed',
  'mix-secondary',
  'share',
  'mixed'
]

function MixSection() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('inner')
      },
        tag('div', {
          className: bem.element('text-wrapper')
        },
          tag('div', {
            className: bem.element('title')
          },
            `With a little help `,
            tag('span', {
              className: bem.element('title-emphasis')
            },
              `from our friends.`
            )
          ),
          tag('div', {
            className: bem.element('subtitle')
          },
            `Save and share your favorite finds for others to discover. The more you Mix, the better it gets
            for all of us. Together, let’s make the internet a better place.`
          )
        ),
        tag(MixOrbit)
      )
    )
  )
}

function MixOrbit() {
  return (
    tag('div', {
      className: bem.element('image-wrapper')
    },
      tag('div', {
        className: bem.element('image')
      },
        tag('div', {
          className: bem.element('planet')
        }),
        tag('div', {
          className: bem.element('orbit')
        },
          satellites.map((satellite, index) => (
            tag('div', {
              className: bem.element('satellite', satellite),
              key: `satellite-${index}`
            })
          ))
        )
      )
    )
  )
}

module.exports = MixSection
